import VenereAnalysis from '../../shared/ui/icons/VenereAnalysis';
import VenereDoctor from '../../shared/ui/icons/VenereDoctor';
import VenereHealthyFood from '../../shared/ui/icons/VenereHealthyFood';
import VenereHeart from '../../shared/ui/icons/VenereHeart';
import VenerePlanner from '../../shared/ui/icons/VenerePlanner';
import VenereScan from '../../shared/ui/icons/VenereScan';
import { FolderItem } from '../components/VenereFoldersGrid';

// We'll replace these with actual icons later
// For now, we'll use a simple object structure
export const FOLDER_ITEMS: FolderItem[] = [
  {
    id: 'prescriptions',
    title: 'Prescrizioni e referti',
    icon: VenereDoctor,
    redirect: '/venere/prescriptions',
  },
  {
    id: 'health-assessments',
    title: 'Questionari anamnestici',
    icon: VenerePlanner,
    redirect: '/venere/assessments',
  },
  {
    id: 'blood-exams',
    title: 'Esami del sangue',
    icon: VenereAnalysis,
    redirect: '/venere/blood-exams',
  },
  {
    id: 'meal-plan',
    title: 'Piano alimentare',
    icon: VenereHealthyFood,
    redirect: '/venere/meal-plan',
  },
  {
    id: 'dna-test',
    title: 'DNA Test',
    icon: VenereHeart,
    redirect: '/venere/dna-test',
  },
  {
    id: 'other',
    title: 'Altro',
    icon: VenereScan,
    redirect: '/venere/other',
  },
]; 